export const CaliforniaBurrito = () => {
  return (
    <div>
      {" "}
      <div
        className=""
        id="californiaBurritoModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contactModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-lg-4">
                  <img
                    className="profile-image"
                    id="imageMainCalifornia"
                    src="/images/executioners/burrito1.jpg"
                    alt="California Burrito campaign"
                    style={{ margin: "10px 0" }}
                  />
                  <div className="col-lg-3">
                    <img
                      className="imageSubCalifornia"
                      src="/images/executioners/burrito2.jpg"
                      alt="California Burrito campaign detail"
                      style={{
                        height: "100%",
                        width: "100%",
                        margin: "10px 0",
                      }}
                    />
                  </div>
                  <div className="col-lg-3">
                    <img
                      className="imageSubCalifornia"
                      src="/images/executioners/burrito3.jpg"
                      alt="California Burrito campaign detail"
                      style={{
                        height: "100%",
                        width: "100%",
                        margin: "10px 0",
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="modal-title-container">
                    <h4 className="modal-title" id="contactModalLabel">
                      California Burrito
                    </h4>
                  </div>
                  <div className="modal-body-container">
                    <p className="helvetica-nueue">
                      <strong>OBJECTIVE</strong>
                    </p>
                    <p>
                      Create a consistent, breakthrough image to facilitate
                      franchising of this successful, high-end local Mexican
                      food chain.
                    </p>
                    <p className="helvetica-nueue">
                      <strong>EXECUTION</strong>
                    </p>
                    <p>
                      Leveraging a paraphrase of the famous Beach Boys song,
                      ‘Wish They Could All Be California Girls,’ and combining
                      it with humorous 1950’s photos of Americans in Mexico, we
                      created a campaign that appealed to a sophisticated GenY
                      market, yet did not exclude GenX or baby-boomers. From the
                      foundation of this tagline, we created print, TV, radio,
                      postcards and all POP merchandising materials.{" "}
                    </p>
                    <p className="helvetica-nueue">
                      <strong>RESULTS</strong>
                    </p>
                    <p>
                      The franchise went from 2 stores to 11 stores in the NY/NJ
                      metropolitan area in less than a year.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
